module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "teak-cove-timber-hayman-0.0522bf65.jpg";